import { createContext } from 'react';

export interface AnalyticsMetaCtx {
  entryPoint: string | undefined;
  additionalEventProps: Record<string, unknown>;
}

export const defaultContextValues: AnalyticsMetaCtx = {
  entryPoint: undefined,
  additionalEventProps: {},
};

const AnalyticsMetaContext = createContext<AnalyticsMetaCtx>(defaultContextValues);

export default AnalyticsMetaContext;
